/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  MyBadgesResponse,
  MyStreakEntry,
  MyStreaksResponse,
  PlatformStreakLeaderboardResponse,
  SharedStreakInvitationListResponse,
  SharedStreakInviteBody,
  SharedStreakInviteResponse,
  SharedStreakLeaveResponse,
  StreakChallengeDetailResponse,
  StreakChallengeListResponse,
  StreakFreezePurchaseResponse,
  StreakPauseResponse,
  StreakStatus,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    MyBadgesResponseFromJSON,
    MyBadgesResponseToJSON,
    MyStreakEntryFromJSON,
    MyStreakEntryToJSON,
    MyStreaksResponseFromJSON,
    MyStreaksResponseToJSON,
    PlatformStreakLeaderboardResponseFromJSON,
    PlatformStreakLeaderboardResponseToJSON,
    SharedStreakInvitationListResponseFromJSON,
    SharedStreakInvitationListResponseToJSON,
    SharedStreakInviteBodyFromJSON,
    SharedStreakInviteBodyToJSON,
    SharedStreakInviteResponseFromJSON,
    SharedStreakInviteResponseToJSON,
    SharedStreakLeaveResponseFromJSON,
    SharedStreakLeaveResponseToJSON,
    StreakChallengeDetailResponseFromJSON,
    StreakChallengeDetailResponseToJSON,
    StreakChallengeListResponseFromJSON,
    StreakChallengeListResponseToJSON,
    StreakFreezePurchaseResponseFromJSON,
    StreakFreezePurchaseResponseToJSON,
    StreakPauseResponseFromJSON,
    StreakPauseResponseToJSON,
    StreakStatusFromJSON,
    StreakStatusToJSON,
} from '../models/index';

export interface CreateStreaksMeStreakConfigIdFreezePurchaseRequest {
    streakConfigId: string;
    body?: object;
}

export interface CreateStreaksMeStreakConfigIdPauseRequest {
    streakConfigId: string;
    body: object;
}

export interface CreateStreaksMeStreakConfigIdUnpauseRequest {
    streakConfigId: string;
    body: object;
}

export interface CreateStreaksSharedGroupIdLeaveRequest {
    groupId: string;
    body: object;
}

export interface CreateStreaksSharedInviteRequest {
    sharedStreakInviteBody: SharedStreakInviteBody;
}

export interface GetStreaksChallengesIdRequest {
    id: string;
}

export interface GetStreaksMeRequest {
    status?: StreakStatus;
    includeAvailable?: GetStreaksMeIncludeAvailableEnum;
}

export interface GetStreaksMeBadgesRequest {
    streakConfigId?: string;
}

export interface GetStreaksMeStreakConfigIdRequest {
    streakConfigId: string;
}

export interface GetStreaksStreakConfigIdLeaderboardRequest {
    streakConfigId: string;
    limit?: number;
    offset?: number;
}

export interface UpdateStreaksSharedInvitationsIdAcceptRequest {
    id: string;
    body: object;
}

export interface UpdateStreaksSharedInvitationsIdDeclineRequest {
    id: string;
    body: object;
}

/**
 * StreaksApi - interface
 * 
 * @export
 * @interface StreaksApiInterface
 */
export interface StreaksApiInterface {
    /**
     * Purchase a streak freeze with Fuel
     * @param {string} streakConfigId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    createStreaksMeStreakConfigIdFreezePurchaseRaw(requestParameters: CreateStreaksMeStreakConfigIdFreezePurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakFreezePurchaseResponse>>;

    /**
     * Purchase a streak freeze with Fuel
     */
    createStreaksMeStreakConfigIdFreezePurchase(requestParameters: CreateStreaksMeStreakConfigIdFreezePurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakFreezePurchaseResponse>;

    /**
     * Pause a streak (it stops lapsing while paused, up to maxPauseDays)
     * @param {string} streakConfigId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    createStreaksMeStreakConfigIdPauseRaw(requestParameters: CreateStreaksMeStreakConfigIdPauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakPauseResponse>>;

    /**
     * Pause a streak (it stops lapsing while paused, up to maxPauseDays)
     */
    createStreaksMeStreakConfigIdPause(requestParameters: CreateStreaksMeStreakConfigIdPauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakPauseResponse>;

    /**
     * Unpause a streak (resumes existing window or computes a new one if expired)
     * @param {string} streakConfigId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    createStreaksMeStreakConfigIdUnpauseRaw(requestParameters: CreateStreaksMeStreakConfigIdUnpauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakPauseResponse>>;

    /**
     * Unpause a streak (resumes existing window or computes a new one if expired)
     */
    createStreaksMeStreakConfigIdUnpause(requestParameters: CreateStreaksMeStreakConfigIdUnpauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakPauseResponse>;

    /**
     * Leave a shared streak group
     * @param {string} groupId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    createStreaksSharedGroupIdLeaveRaw(requestParameters: CreateStreaksSharedGroupIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakLeaveResponse>>;

    /**
     * Leave a shared streak group
     */
    createStreaksSharedGroupIdLeave(requestParameters: CreateStreaksSharedGroupIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakLeaveResponse>;

    /**
     * Send a shared streak invitation to another user
     * @param {SharedStreakInviteBody} sharedStreakInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    createStreaksSharedInviteRaw(requestParameters: CreateStreaksSharedInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>>;

    /**
     * Send a shared streak invitation to another user
     */
    createStreaksSharedInvite(requestParameters: CreateStreaksSharedInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse>;

    /**
     * List active and upcoming streak challenges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksChallengesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakChallengeListResponse>>;

    /**
     * List active and upcoming streak challenges
     */
    getStreaksChallenges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakChallengeListResponse>;

    /**
     * Get streak challenge details with user standing and top leaderboard
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksChallengesIdRaw(requestParameters: GetStreaksChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakChallengeDetailResponse>>;

    /**
     * Get streak challenge details with user standing and top leaderboard
     */
    getStreaksChallengesId(requestParameters: GetStreaksChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakChallengeDetailResponse>;

    /**
     * Get all streak progress for the authenticated user, including config details
     * @param {StreakStatus} [status] Filter by streak status
     * @param {'true' | 'false'} [includeAvailable] Include active public configs the user hasn\&#39;t started (default false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksMeRaw(requestParameters: GetStreaksMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyStreaksResponse>>;

    /**
     * Get all streak progress for the authenticated user, including config details
     */
    getStreaksMe(requestParameters: GetStreaksMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyStreaksResponse>;

    /**
     * List all badges the authenticated user has earned, newest first
     * @param {string} [streakConfigId] Only return badges earned from this streak
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksMeBadgesRaw(requestParameters: GetStreaksMeBadgesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyBadgesResponse>>;

    /**
     * List all badges the authenticated user has earned, newest first
     */
    getStreaksMeBadges(requestParameters: GetStreaksMeBadgesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyBadgesResponse>;

    /**
     * Get a single streak\'s progress and config for the authenticated user
     * @param {string} streakConfigId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksMeStreakConfigIdRaw(requestParameters: GetStreaksMeStreakConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyStreakEntry>>;

    /**
     * Get a single streak\'s progress and config for the authenticated user
     */
    getStreaksMeStreakConfigId(requestParameters: GetStreaksMeStreakConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyStreakEntry>;

    /**
     * List pending shared streak invitations for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksSharedInvitationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInvitationListResponse>>;

    /**
     * List pending shared streak invitations for the current user
     */
    getStreaksSharedInvitations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInvitationListResponse>;

    /**
     * Get the public leaderboard for a streak config, ranked by current streak
     * @param {string} streakConfigId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    getStreaksStreakConfigIdLeaderboardRaw(requestParameters: GetStreaksStreakConfigIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformStreakLeaderboardResponse>>;

    /**
     * Get the public leaderboard for a streak config, ranked by current streak
     */
    getStreaksStreakConfigIdLeaderboard(requestParameters: GetStreaksStreakConfigIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformStreakLeaderboardResponse>;

    /**
     * Accept a shared streak invitation
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    updateStreaksSharedInvitationsIdAcceptRaw(requestParameters: UpdateStreaksSharedInvitationsIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>>;

    /**
     * Accept a shared streak invitation
     */
    updateStreaksSharedInvitationsIdAccept(requestParameters: UpdateStreaksSharedInvitationsIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse>;

    /**
     * Decline a shared streak invitation
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreaksApiInterface
     */
    updateStreaksSharedInvitationsIdDeclineRaw(requestParameters: UpdateStreaksSharedInvitationsIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>>;

    /**
     * Decline a shared streak invitation
     */
    updateStreaksSharedInvitationsIdDecline(requestParameters: UpdateStreaksSharedInvitationsIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse>;

}

/**
 * 
 */
export class StreaksApi extends runtime.BaseAPI implements StreaksApiInterface {

    /**
     * Purchase a streak freeze with Fuel
     */
    async createStreaksMeStreakConfigIdFreezePurchaseRaw(requestParameters: CreateStreaksMeStreakConfigIdFreezePurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakFreezePurchaseResponse>> {
        if (requestParameters['streakConfigId'] == null) {
            throw new runtime.RequiredError(
                'streakConfigId',
                'Required parameter "streakConfigId" was null or undefined when calling createStreaksMeStreakConfigIdFreezePurchase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me/{streakConfigId}/freeze/purchase`;
        urlPath = urlPath.replace(`{${"streakConfigId"}}`, encodeURIComponent(String(requestParameters['streakConfigId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreakFreezePurchaseResponseFromJSON(jsonValue));
    }

    /**
     * Purchase a streak freeze with Fuel
     */
    async createStreaksMeStreakConfigIdFreezePurchase(requestParameters: CreateStreaksMeStreakConfigIdFreezePurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakFreezePurchaseResponse> {
        const response = await this.createStreaksMeStreakConfigIdFreezePurchaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Pause a streak (it stops lapsing while paused, up to maxPauseDays)
     */
    async createStreaksMeStreakConfigIdPauseRaw(requestParameters: CreateStreaksMeStreakConfigIdPauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakPauseResponse>> {
        if (requestParameters['streakConfigId'] == null) {
            throw new runtime.RequiredError(
                'streakConfigId',
                'Required parameter "streakConfigId" was null or undefined when calling createStreaksMeStreakConfigIdPause().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createStreaksMeStreakConfigIdPause().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me/{streakConfigId}/pause`;
        urlPath = urlPath.replace(`{${"streakConfigId"}}`, encodeURIComponent(String(requestParameters['streakConfigId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreakPauseResponseFromJSON(jsonValue));
    }

    /**
     * Pause a streak (it stops lapsing while paused, up to maxPauseDays)
     */
    async createStreaksMeStreakConfigIdPause(requestParameters: CreateStreaksMeStreakConfigIdPauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakPauseResponse> {
        const response = await this.createStreaksMeStreakConfigIdPauseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unpause a streak (resumes existing window or computes a new one if expired)
     */
    async createStreaksMeStreakConfigIdUnpauseRaw(requestParameters: CreateStreaksMeStreakConfigIdUnpauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakPauseResponse>> {
        if (requestParameters['streakConfigId'] == null) {
            throw new runtime.RequiredError(
                'streakConfigId',
                'Required parameter "streakConfigId" was null or undefined when calling createStreaksMeStreakConfigIdUnpause().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createStreaksMeStreakConfigIdUnpause().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me/{streakConfigId}/unpause`;
        urlPath = urlPath.replace(`{${"streakConfigId"}}`, encodeURIComponent(String(requestParameters['streakConfigId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreakPauseResponseFromJSON(jsonValue));
    }

    /**
     * Unpause a streak (resumes existing window or computes a new one if expired)
     */
    async createStreaksMeStreakConfigIdUnpause(requestParameters: CreateStreaksMeStreakConfigIdUnpauseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakPauseResponse> {
        const response = await this.createStreaksMeStreakConfigIdUnpauseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave a shared streak group
     */
    async createStreaksSharedGroupIdLeaveRaw(requestParameters: CreateStreaksSharedGroupIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakLeaveResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling createStreaksSharedGroupIdLeave().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createStreaksSharedGroupIdLeave().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/shared/{groupId}/leave`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedStreakLeaveResponseFromJSON(jsonValue));
    }

    /**
     * Leave a shared streak group
     */
    async createStreaksSharedGroupIdLeave(requestParameters: CreateStreaksSharedGroupIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakLeaveResponse> {
        const response = await this.createStreaksSharedGroupIdLeaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a shared streak invitation to another user
     */
    async createStreaksSharedInviteRaw(requestParameters: CreateStreaksSharedInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>> {
        if (requestParameters['sharedStreakInviteBody'] == null) {
            throw new runtime.RequiredError(
                'sharedStreakInviteBody',
                'Required parameter "sharedStreakInviteBody" was null or undefined when calling createStreaksSharedInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/shared/invite`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedStreakInviteBodyToJSON(requestParameters['sharedStreakInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedStreakInviteResponseFromJSON(jsonValue));
    }

    /**
     * Send a shared streak invitation to another user
     */
    async createStreaksSharedInvite(requestParameters: CreateStreaksSharedInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse> {
        const response = await this.createStreaksSharedInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List active and upcoming streak challenges
     */
    async getStreaksChallengesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakChallengeListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/challenges`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreakChallengeListResponseFromJSON(jsonValue));
    }

    /**
     * List active and upcoming streak challenges
     */
    async getStreaksChallenges(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakChallengeListResponse> {
        const response = await this.getStreaksChallengesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get streak challenge details with user standing and top leaderboard
     */
    async getStreaksChallengesIdRaw(requestParameters: GetStreaksChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreakChallengeDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStreaksChallengesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/challenges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreakChallengeDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get streak challenge details with user standing and top leaderboard
     */
    async getStreaksChallengesId(requestParameters: GetStreaksChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreakChallengeDetailResponse> {
        const response = await this.getStreaksChallengesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all streak progress for the authenticated user, including config details
     */
    async getStreaksMeRaw(requestParameters: GetStreaksMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyStreaksResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['includeAvailable'] != null) {
            queryParameters['includeAvailable'] = requestParameters['includeAvailable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyStreaksResponseFromJSON(jsonValue));
    }

    /**
     * Get all streak progress for the authenticated user, including config details
     */
    async getStreaksMe(requestParameters: GetStreaksMeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyStreaksResponse> {
        const response = await this.getStreaksMeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all badges the authenticated user has earned, newest first
     */
    async getStreaksMeBadgesRaw(requestParameters: GetStreaksMeBadgesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyBadgesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['streakConfigId'] != null) {
            queryParameters['streakConfigId'] = requestParameters['streakConfigId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me/badges`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyBadgesResponseFromJSON(jsonValue));
    }

    /**
     * List all badges the authenticated user has earned, newest first
     */
    async getStreaksMeBadges(requestParameters: GetStreaksMeBadgesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyBadgesResponse> {
        const response = await this.getStreaksMeBadgesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single streak\'s progress and config for the authenticated user
     */
    async getStreaksMeStreakConfigIdRaw(requestParameters: GetStreaksMeStreakConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyStreakEntry>> {
        if (requestParameters['streakConfigId'] == null) {
            throw new runtime.RequiredError(
                'streakConfigId',
                'Required parameter "streakConfigId" was null or undefined when calling getStreaksMeStreakConfigId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/me/{streakConfigId}`;
        urlPath = urlPath.replace(`{${"streakConfigId"}}`, encodeURIComponent(String(requestParameters['streakConfigId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyStreakEntryFromJSON(jsonValue));
    }

    /**
     * Get a single streak\'s progress and config for the authenticated user
     */
    async getStreaksMeStreakConfigId(requestParameters: GetStreaksMeStreakConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyStreakEntry> {
        const response = await this.getStreaksMeStreakConfigIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pending shared streak invitations for the current user
     */
    async getStreaksSharedInvitationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInvitationListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/shared/invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedStreakInvitationListResponseFromJSON(jsonValue));
    }

    /**
     * List pending shared streak invitations for the current user
     */
    async getStreaksSharedInvitations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInvitationListResponse> {
        const response = await this.getStreaksSharedInvitationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the public leaderboard for a streak config, ranked by current streak
     */
    async getStreaksStreakConfigIdLeaderboardRaw(requestParameters: GetStreaksStreakConfigIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlatformStreakLeaderboardResponse>> {
        if (requestParameters['streakConfigId'] == null) {
            throw new runtime.RequiredError(
                'streakConfigId',
                'Required parameter "streakConfigId" was null or undefined when calling getStreaksStreakConfigIdLeaderboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/{streakConfigId}/leaderboard`;
        urlPath = urlPath.replace(`{${"streakConfigId"}}`, encodeURIComponent(String(requestParameters['streakConfigId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlatformStreakLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Get the public leaderboard for a streak config, ranked by current streak
     */
    async getStreaksStreakConfigIdLeaderboard(requestParameters: GetStreaksStreakConfigIdLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformStreakLeaderboardResponse> {
        const response = await this.getStreaksStreakConfigIdLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept a shared streak invitation
     */
    async updateStreaksSharedInvitationsIdAcceptRaw(requestParameters: UpdateStreaksSharedInvitationsIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStreaksSharedInvitationsIdAccept().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateStreaksSharedInvitationsIdAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/shared/invitations/{id}/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedStreakInviteResponseFromJSON(jsonValue));
    }

    /**
     * Accept a shared streak invitation
     */
    async updateStreaksSharedInvitationsIdAccept(requestParameters: UpdateStreaksSharedInvitationsIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse> {
        const response = await this.updateStreaksSharedInvitationsIdAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Decline a shared streak invitation
     */
    async updateStreaksSharedInvitationsIdDeclineRaw(requestParameters: UpdateStreaksSharedInvitationsIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedStreakInviteResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStreaksSharedInvitationsIdDecline().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateStreaksSharedInvitationsIdDecline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streaks/shared/invitations/{id}/decline`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedStreakInviteResponseFromJSON(jsonValue));
    }

    /**
     * Decline a shared streak invitation
     */
    async updateStreaksSharedInvitationsIdDecline(requestParameters: UpdateStreaksSharedInvitationsIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedStreakInviteResponse> {
        const response = await this.updateStreaksSharedInvitationsIdDeclineRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetStreaksMeIncludeAvailableEnum = {
    True: 'true',
    False: 'false'
} as const;
export type GetStreaksMeIncludeAvailableEnum = typeof GetStreaksMeIncludeAvailableEnum[keyof typeof GetStreaksMeIncludeAvailableEnum];
